import { Box, Typography } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  noPreviewAvailable: {
    id: 'autoCuration.pdfSplitEditor.noPreviewAvailable',
    defaultMessage: 'No preview available',
  },
});

interface PdfEmptyStateProps {
  className?: string;
  height?: string | number;
  width?: string | number;
}

export const PdfEmptyState: React.FC<PdfEmptyStateProps> = ({
  className = '',
  height = '600px',
  width = '100%',
}) => {
  const { formatMessage } = useIntl();

  return (
    <Box
      className={className}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'grey.100',
        border: 1,
        borderColor: 'grey.300',
        borderRadius: 1,
        height,
        width,
      }}
    >
      <Typography color="text.secondary">
        {formatMessage(messages.noPreviewAvailable)}
      </Typography>
    </Box>
  );
};
